import request from "@/utils/request";


export const appConfigPub = (param) => request.get('/patch/app_config_pub/get', param);

//短信推广
export const wechat = (param) => request.post('/patch/wechat_popularize_pub/get', param);